<template>
  <div class="container">
  <div class="gk-admin-portal row">
    <div class="icon-logo" alt="Home"></div>
    <h2>NEIS Web Portal</h2>
  </div>
  
  
  <div class=" row justify-content-center">
    <div class="card w-50 login-panel">
      <div class="card-body">
        <h1 :class="{ success: success }" >Forgot Password</h1>
        <div v-if="!success" class="form-container">
          <form @submit.prevent="forgotPassword" autocomplete="off" >
            <span class="login-instruction">Enter your email to reset password!</span>
            <div v-if="error" class="alert alert-danger" role="alert">
              There was an error sending your email. Please try again.
            </div> 
            
            <div class="form-group row">
              <div class="col-sm-10">
                <input type="email" v-model="email" class="form-control" id="inputEmail3" placeholder="Email" >
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-10 fl-right">
                <button type="submit" class="btn btn-primary">Send Email</button>
              </div>
            </div>
          </form>
        </div>
        <div v-else> 
            <p class="success-message">An email has been sent your email address. Follow the instructions in the email to reset your password.
            </p>
          </div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import { Config, PortalUser } from '../api';
import store from '../store'

export default {
    name: "login",
    data() {
      return {
        email: "",
        error: false,
        success: false
      }
    },
    props: [],
    methods: {
      async forgotPassword(){

        let response = await store.dispatch('forgotPassword', this.email);
        console.log("Forgot Password", response);
        if(response){
          this.error = false;
          this.success = true;
        }else{
          this.success = false;
          this.error = true;
        }
      }
    },
}
</script>

<style lang="scss" scoped>
@import "../css/constants";

//Reset row
.row {
  margin: 0;
}
.gk-admin-portal {
  width: 52vw;
  display: flex;
  margin-top: -4rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    /* Administrator Portal: */
    font-size: $p20;
  }
}
.icon-logo{
  background-size: 12rem 12rem;
  width: 12rem;
  height: 12rem;
  margin: auto;
  margin-bottom: $p16;
  background-repeat: no-repeat;
}

.version-number {
  /* Rectangle: */
  font-size: $p14;
  padding: 6px 8px;
  padding-top: 8px;
  margin-top: $p16;
  color: $gray5;
  background: $gray2;
  border: 1px solid $gray4;
  border-radius: 4px;
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin: 0;
  width: 100vw;
  background:$gray2;
}
input, input:focus {
  width: 300px;
  padding-top: 10px;
  height: 40px;
}
.login-panel {
  width: 48vw;
  height: 100vh;
  justify-content: center;
  box-shadow: none;
  border-radius: 0;
  -webkit-clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(14% 0%, 100% 0, 100% 100%, 0% 100%);

  /* Rectangle 35: */
  background-image: linear-gradient(-180deg, #56ccf2 0%, #2f80ed 100%);

  .card-body {
    align-self: center;
    width: 300px;
    margin-left: $p52;
    margin-top: -3rem;
    justify-content: space-between;
    
    .alert{ margin-top: 15px; }
    .form-group {
      margin-top: $p16;
      margin-bottom: $p24;
    }
    a {
      color: white;
      font-size: $p14;
      &:hover {
        color: white;
        cursor: pointer;
      }
    }

    h1{
        font-size: 40px;
        color: white;
        margin-bottom: 20px;
        line-height: 1.0em;
        text-align: center;
    }
    
    h1.success{ text-align: center; }
  }
  .login-instruction {
    font-size: 1em;
    color: white;
  }
}

.col-sm-10 {
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
}

.btn-primary {
  border-radius: 100px;
	color: #243c98;
	padding: 9px $p40;
	padding-top: $p10;
  padding-left: $p24;
  padding-right: $p56;
	background: white;
	border: none;
  background-image: url('../assets/sign-in-arrow.svg');
  background-size: $p20;
  background-position: 108px 11px;
  background-repeat: no-repeat;
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &:active {
    background-color: white;
    color: $gkred;
  }
}

.success-message{
  padding-top: 15%;
  color: white;
  line-height: 30px;
  text-align: center;
}

.form-container{
  padding-top: 20px;
}

@media only screen and (max-width: 768px) {
  .gk-admin-portal{
    width: 100vw;
    height: 40vh;
    .icon-logo{
      margin-top: 5vh;
      margin-bottom: 10px;
    }
  }
  .container{
    display: flex;
    flex-direction: column;
  }

  .row{
    .login-panel{
      height: 60vh;
      width: 100vw;
      -webkit-clip-path: none;
      clip-path: none;

      .btn-primary{
        background-image: none;
      }
    }
  }
}

@media only screen and (max-width: 468px) {
  .gk-admin-portal{
    .icon-logo{
      background-size: 10rem 10rem;
      width: 10rem;
      height: 10rem;
    }
  }

  .row{
    .login-panel{
      h1{
        font-size: 30px;
        margin-bottom: 0px;
      }

      input{
        width: 250px;
      }

      .form-container{
        padding-top: 10px;
      }

      .card-body{
        margin-left: 20px;
      }
      .btn-primary{
        width: 130px;
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue